import { Card } from '@/components/ui/card'

export default function FeaturesGrid({ title, subtitle, features, cardClassName = "", iconClassName = "", titleClassName = "", descClassName = "" }) {
  return (
    <section className="py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold mb-2">{title}</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-sm">{subtitle}</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {features.map((feat, idx) => (
            <Card key={idx} className={`text-center transition-all hover:shadow-sm ${cardClassName}`}>
              <div className={`mx-auto mb-2 flex items-center justify-center rounded-full bg-primary/10 text-primary ${iconClassName}`}>
                <feat.icon className="h-5 w-5" />
              </div>
              <h3 className={`text-sm font-semibold mb-1 ${titleClassName}`}>{feat.title}</h3>
              <p className={`text-xs text-muted-foreground ${descClassName}`}>{feat.desc}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}